export const transformStudentProgressNotifcations = (data) =>
  Object.entries(data ?? {}).map(([crn, value]) => ({
    crn,
    title: `${value.subjectCode} ${value.courseNumber} - ${value.courseTitle} - ${value.instructorName}`,
    ...value,
    recordsCount: value?.records?.length ?? 0,
  }));

export const getTotalStudentProgressNotifications = (data) =>
  data.reduce((sum, item) => sum + item.recordsCount, 0);
